import type React from 'react';

import Config, { type BrainAtlasType, type MultiLang } from '../config';
import ItemType from './item-type';

import styles from './XoonipsTop.module.css';

interface Props {
    lang: MultiLang;
    type: BrainAtlasType;
}

const XoonipsTop: React.FC<Props> = (props) => {
    const { lang, type } = props;
    const types: string[][] = [];
    const len = Config.XOONIPS_ITEMTYPES.length;
    for (let i = 0; i < Math.ceil(len / 2); i++) {
        const j = i * 2;
        const p = Config.XOONIPS_ITEMTYPES.slice(j, j + 2);
        types.push(p);
    }
    return (
        <table className={styles.itemTypes}>
            <tbody>
                {types.map((value, _idx) => {
                    return (
                        <tr key={value.join('-')}>
                            {value.map((itemType, _idx) => {
                                return (
                                    <td key={itemType} className={styles.itemType}>
                                        {itemType !== '' && (
                                            <ItemType.Top lang={lang} itemType={`xnp${itemType}`} type={type} />
                                        )}
                                    </td>
                                );
                            })}
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};

export default XoonipsTop;
